export default __webpack_public_path__ + "images/c4f6af214bfbb874d01a4cfd317e69df.png";